
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/[section]/[detail]",
      function () {
        return require("private-next-pages/share/[section]/[detail].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/[section]/[detail]"])
      });
    }
  